import React, { useState } from 'react';
import './NonDeviceEdit.css';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormGroup,
  Row,
} from 'react-bootstrap';
import LoadingButton from '../LoadingButton/LoadingButton';
import {
  Field,
  Formik,
} from 'formik';
import { useStores } from '../../hooks/use-stores';
import { nonDeviceDefaultStyles } from '../../constants/DefaultNonDeviceGUI';

const NonDeviceEdit = props => {
  const { id, onSave = () => {}, onClose = () => {} } = props;
  const [ loading, setLoading ] = useState(false);
  const { devicesStore } = useStores();
  const nonDevice = devicesStore.getNonDeviceGUIById(id);

  const onReset = (values, setValues) => {
    setValues({
      ...values,
      ...nonDeviceDefaultStyles,
    });
  };

  return !nonDevice ? '' : (
    <Col sm={12} className="non-device-edit">
      <h4 onClick={() => onClose()}><i className="fa fa-arrow-left"/> {nonDevice.label}</h4>
      <Formik
        onSubmit={(values) => {
          setLoading(true);
          devicesStore.upsertNonDeviceGUI(id, values, () => {
            setLoading(false);
            onSave();
          });
        }}
        initialValues={{
          ...nonDevice,
        }}
      >{({
          handleSubmit,
          handleChange,
          setValues,
          values }) => (
          <Form className="edit-device-form">
            <Row className="form-fields">
              <Col sm={4} xs={4}>
                <FormGroup>
                  <ControlLabel>Color</ControlLabel>
                  <Field name={'color'}
                    type="color"
                    value={values.color || ''}
                    onChange={handleChange}
                    className="form-control input-sm narrow-pad"/>
                </FormGroup>
              </Col>
              <Col sm={4} xs={4}>
                <FormGroup>
                  <ControlLabel>Background</ControlLabel>
                  <Field name={'background'}
                    type="color"
                    value={values.background || ''}
                    onChange={handleChange}
                    className="form-control input-sm narrow-pad"/>
                </FormGroup>
              </Col>
              <Col sm={4} xs={4}>
                <FormGroup>
                  <ControlLabel>Font Size</ControlLabel>
                  <Field name={'fontSize'}
                    type="number"
                    min={10}
                    max={40}
                    value={values.fontSize || ''}
                    onChange={handleChange}
                    className="form-control input-sm narrow-pad"/>
                </FormGroup>
              </Col>
            </Row>
            <Row className="form-buttons padding-tb-10">
              <Col sm={12} className="text-right">
                <Button type="button"  onClick={() => onClose()}>
                  {'Close'}
                </Button>
                <Button type="button"  onClick={() => onReset(values, setValues)}>
                  {'Reset'}
                </Button>
                <LoadingButton
                  bsStyle="primary"
                  type="submit"
                  label={'Save'}
                  loadingLabel={'Saving'}
                  onClick={handleSubmit}
                  isLoading={loading}
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Col>
  );
};

export default NonDeviceEdit;
